var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTetherIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.95,
    width: 40,
    height: 40,
    rx: 5,
    fill: "#F3F6F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_2293)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.493 7.12309L5.02298 18.201C5.00216 18.2422 4.99557 18.2887 5.00415 18.3338C5.01274 18.3789 5.03606 18.4201 5.0707 18.4515L19.844 32.1003C19.886 32.1391 19.9419 32.1608 20 32.1608C20.0581 32.1608 20.114 32.1391 20.156 32.1003L34.9293 18.4524C34.9639 18.421 34.9872 18.3797 34.9958 18.3347C35.0044 18.2896 34.9978 18.243 34.977 18.2018L29.507 7.12394C29.4893 7.08674 29.4609 7.05522 29.4252 7.03316C29.3895 7.0111 29.3479 6.99942 29.3054 6.99953H10.6963C10.6537 6.99902 10.6118 7.01041 10.5757 7.03234C10.5397 7.05426 10.5109 7.08578 10.493 7.12309Z",
    fill: "#50AF95"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8978 19.3386C21.7917 19.3463 21.2437 19.3778 20.0214 19.3778C19.0492 19.3778 18.3589 19.3497 18.1167 19.3386C14.3596 19.1793 11.5552 18.5487 11.5552 17.7937C11.5552 17.0387 14.3596 16.4089 18.1167 16.247V18.7106C18.3624 18.7276 19.066 18.7677 20.0382 18.7677C21.2049 18.7677 21.7891 18.7208 21.8942 18.7114V16.2487C25.6435 16.4098 28.4417 17.0404 28.4417 17.7937C28.4417 18.547 25.6444 19.1776 21.8942 19.3378L21.8978 19.3386ZM21.8978 15.9939V13.7894H27.1301V10.4277H12.8844V13.7894H18.1159V15.9931C13.8637 16.1814 10.666 16.9935 10.666 17.9667C10.666 18.9398 13.8637 19.7511 18.1159 19.9402V27.0045H21.8969V19.9377C26.1393 19.7493 29.3317 18.9381 29.3317 17.9658C29.3317 16.9935 26.142 16.1823 21.8969 15.9931L21.8978 15.9939Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_2293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 25.1613,
    fill: "white",
    transform: "translate(5 6.99951)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTetherIcon);
export default __webpack_public_path__ + "static/media/TetherIcon.a829c9c000787b188f74c4edd3b6b498.svg";
export { ForwardRef as ReactComponent };